import { useEffect, useState } from "react";
import { Layout } from "../components/Layout";
import { api } from "../lib/api";
import { VerdictPill } from "../components/VerdictBadge";

export default function CorporateAcquisitions() {
  const [rows, setRows] = useState([]);
  const [src, setSrc] = useState("");
  const [verdict, setVerdict] = useState("");

  const load = () => {
    const params = new URLSearchParams();
    if (src) params.set("source", src);
    if (verdict) params.set("verdict", verdict);
    params.set("limit", "150");
    api.get(`/acquisitions?${params.toString()}`).then((r) => setRows(r.data));
  };
  useEffect(load, [src, verdict]);

  return (
    <Layout variant="corporate">
      <div className="flex items-end justify-between mb-6">
        <div>
          <div className="text-[11px] uppercase tracking-wider text-slate-500 font-semibold">Corporate</div>
          <h1 className="text-3xl font-bold text-navy">Acquisitions</h1>
        </div>
        <div className="flex gap-2">
          <select data-testid="filter-source" value={src} onChange={(e) => setSrc(e.target.value)}
                  className="h-9 px-3 rounded-md border border-slate-300 text-xs font-semibold uppercase tracking-wider bg-white">
            <option value="">All sources</option>
            <option value="auction">Auction</option>
            <option value="trade">Trade</option>
            <option value="service_drive">Service drive</option>
            <option value="private_party">Private party</option>
          </select>
          <select data-testid="filter-verdict" value={verdict} onChange={(e) => setVerdict(e.target.value)}
                  className="h-9 px-3 rounded-md border border-slate-300 text-xs font-semibold uppercase tracking-wider bg-white">
            <option value="">All verdicts</option>
            <option value="strong_buy">Strong buy</option>
            <option value="buy">Buy</option>
            <option value="conditional">Conditional</option>
            <option value="pass">Pass (override)</option>
          </select>
        </div>
      </div>

      <div className="bg-white border border-slate-200 rounded-xl overflow-hidden">
        <table className="w-full text-sm" data-testid="acquisitions-table">
          <thead className="bg-slate-50 border-b border-slate-200">
            <tr className="text-[10px] uppercase tracking-wider text-slate-600">
              <th className="text-left px-4 py-3 font-bold">Date</th>
              <th className="text-left px-4 py-3 font-bold">Vehicle</th>
              <th className="text-left px-4 py-3 font-bold">Rooftop</th>
              <th className="text-left px-4 py-3 font-bold">Buyer</th>
              <th className="text-left px-4 py-3 font-bold">Source</th>
              <th className="text-right px-4 py-3 font-bold">Acq $</th>
              <th className="text-right px-4 py-3 font-bold">Recon</th>
              <th className="text-right px-4 py-3 font-bold">Retail $</th>
              <th className="text-right px-4 py-3 font-bold">Gross</th>
              <th className="text-center px-4 py-3 font-bold">Verdict</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((a) => (
              <tr key={a.acquisition_id} className="border-b border-slate-100 hover:bg-slate-50">
                <td className="px-4 py-3 text-xs text-slate-600 tabular">{new Date(a.acquisition_date).toLocaleDateString()}</td>
                <td className="px-4 py-3 font-semibold text-navy">{a.year} {a.make} {a.model} <span className="text-slate-500 font-normal">{a.trim}</span></td>
                <td className="px-4 py-3 text-xs text-slate-600">{a.rooftop_name?.replace("Ourisman ", "")}</td>
                <td className="px-4 py-3 text-xs text-slate-600">{a.buyer_name}</td>
                <td className="px-4 py-3 text-xs uppercase tracking-wider text-slate-500 font-semibold">{a.source.replace("_", " ")}</td>
                <td className="px-4 py-3 text-right tabular font-bold">${a.acquisition_price.toLocaleString()}</td>
                <td className="px-4 py-3 text-right tabular text-slate-600">${a.recon_actual.toLocaleString()}</td>
                <td className="px-4 py-3 text-right tabular font-semibold">{a.retail_price ? `$${a.retail_price.toLocaleString()}` : "—"}</td>
                <td className={`px-4 py-3 text-right tabular font-bold ${a.final_gross > 0 ? "text-verdict-strongText" : a.final_gross < 0 ? "text-verdict-passText" : "text-slate-400"}`}>
                  {a.final_gross != null ? `${a.final_gross >= 0 ? "+" : ""}$${a.final_gross.toLocaleString()}` : "—"}
                </td>
                <td className="px-4 py-3 text-center"><VerdictPill verdict={a.verdict_at_acquisition} /></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </Layout>
  );
}
